import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchActiveFindingCVEDetails,
  fetchCVEDetailsGraph,
  fetchActiveCVEDetailsTotal,
  fetchCVEDetailsAction,
} from "../../actions/vulnerability";
import { Link, useParams } from "react-router-dom";
import BasicLineColumn from "../common/apexChart/lineChart";
import moment from "moment";
import Pagination from "../Pagination/Pagination";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { Donut } from "react-dial-knob";
import GaugeChart from "react-gauge-chart";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import KnownsubscribersChart from "../common/dashboard9/knownsubscribersChart";

const InfrastructureVAIP = () => {
  const { finding } = useParams();
  const dispatch = useDispatch();
  const myRef = useRef(null);
  const [filterData, setfilterData] = useState("all");
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [search, setsearch] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [category, setCategory] = useState("all");
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [ipFilter, setIpFilter] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");

  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');

  const styles = {
      card: {
        backgroundColor: '#0000',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
        borderRadius: '8px',
        overflow: 'hidden',
        fontFamily: 'Arial, sans-serif',
        color: '#e5e7eb',
      },
      header: {
        backgroundColor: '#111827',
        padding: '12px 16px',
        borderBottom: '1px solid #374151',
      },
      headerText: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#f3f4f6',
      },
      content: {
        padding: '16px',
        backgroundColor:"#fff",
        paddingBottom: '24px',
      },
      grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '16px',
      },
      infoItem: {
        display: 'flex',
        alignItems: 'center',
      },
      icon: {
        marginRight: '8px',
        color: '#211F54',
      },
      label: {
        fontWeight: 'bold',
        color: '#211F54',
      },
      value: {
        color: '#211F54',
      },
      section: {
        marginTop: '16px',
      },
      sectionTitle: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#211F54',
        marginBottom: '8px',
      },
      sectionContent: {
        color: '#211F54',
      },
      link: {
        color: '#60a5fa',
        textDecoration: 'none',
      },
    };

    const getRiskColor = (risk) => {
      switch (risk) {
        case 'Critical': return '#ef4444';
        case 'High': return '#ef4444';
        case 'Medium': return '#f59e0b';
        case 'Low': return '#10b981';
        default: return '#211F54';
      }
    };

    const InfoItem = ({ iconSvg, label, value }) => (
        <div style={styles?.infoItem}>
          <span style={styles?.icon} dangerouslySetInnerHTML={{ __html: iconSvg }} />
          <div>
            <span style={styles?.label}>{label}: </span>
            <span style={styles?.value}>{value}</span>
          </div>
        </div>
      );

  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });

  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  let table = useSelector(
    (state) => state.vulnerability?.cveDetails?.data
  );

  let totalCount = useSelector((state) => state.vulnerability?.cveTotal?.data);

  const pagination = useSelector(
    (state) => state.vulnerability?.cveDetails?.data
  );

  let scanCompleted = useSelector(
    (state) => state.vulnerability?.scanCompleted
  );
  const executeScroll = (val) => {
    setfilterData(val);
    myRef.current.scrollIntoView(); // run this function from an event handler or pass it to useEffect to execute scroll
  };

  const scanDetails = useSelector(
    (state) => state?.vulnerability?.cveGraph?.data
  );

  const auth = useSelector((state) => state?.auth?.user);
  const iPDetails = useSelector(
    (state) => state?.vulnerability?.cveDetails?.scanDetailArray?.ipDetails
  );

  useEffect(() => {
    if (orgId) {
      fetchActiveFindingCVEDetails(orgId, dispatch, page, PageSize, search, category, ipFilter, finding);
    } else {
      fetchActiveFindingCVEDetails(id, dispatch, page, PageSize, search, category, ipFilter, finding);
    }
  }, [id, dispatch, page, PageSize, search, category, ipFilter]);

  useEffect(() => {
    setTotalItems(pagination?.totalFindings);
  }, [pagination?.totalFindings]);

  useEffect(() => {
    fetchActiveCVEDetailsTotal(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    fetchCVEDetailsGraph(id, dispatch);
  }, [id, dispatch]);

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event) => {
    if (event == "") {
    }

    if (event == "riskAccepted") {
    }

    if (event == "markAsFalsePositive") {
    }

    if (event == "markAsRemidiated") {
      let ids = [];
      ids.push(_id);
      const data = {
        action: "markAsRemidiated",
        pvaIds: selectedIds == 0 ? ids : selectedIds,
        actionNote: "",
        for: "forever",
      };
      fetchCVEDetailsAction(
        id,
        dispatch,
        page,
        PageSize,
        search,
        category,
        data
      );
      setSelectedValue("pleaseSelect");
      setActionNote("");
      setSelectedIds([]);
    }
  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      pvaIds: selectedIds == 0 ? ids : selectedIds,
    };
    fetchCVEDetailsAction(id, dispatch, page, PageSize, search, category, data);
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      pvaIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    fetchCVEDetailsAction(id, dispatch, page, PageSize, search, category, data);
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  let ipArray = [];
  for (let details = 0; details < scanDetails?.scanDetails?.length; details++) {
    ipArray.push(scanDetails?.scanDetails?.[details]?.length || 0);
  }

  let mapData = table;

  let currentTableData = [];

  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  const severity = (val) => {
    if (val < 4) {
      return "Low";
    }
    if (val >= 4 && val < 7) {
      return "Medium";
    }
    if (val >= 7 && val < 9) {
      return "High";
    }
    if (val >= 9) {
      return "Critical";
    }
  };

  const severityBatch = (val) => {
    if (val < 4) {
      return "badge badge-low";
    }
    if (val >= 4 && val < 7) {
      return "badge badge-med";
    }
    if (val >= 7 && val < 9) {
      return "badge badge-high";
    }
    if (val >= 9) {
      return "badge badge-critical";
    }
  };

  return (
    <>
      <div className="container-fluid">
        <AccessPage></AccessPage>
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1 className="welcome-text">Active Vulnerability Assessment</h1>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                      {vendorId ? <>
                        <Link to="/vendor"
                          onClick={(() => {
                            sessionStorage.clear();
                          })}
                        >Vendor Assessment</Link>
                      </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                     <Link to="/active-va">Active VA</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                   Ip details
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                  CVE information
                  </li>
                </ol>
                <br />
              </nav>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-12 col-md-12">
            <div style={styles?.card}>
                  <div style={styles?.header}>
                    <h3 style={styles?.headerText}>Vulnerability Information</h3>
                  </div>
                  <div style={styles?.content}>
                    <div style={styles?.grid}>
                      <InfoItem
                        iconSvg='<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>'
                        label="IP Address"
                        value={mapData?.ipAddress}
                      />
                      <InfoItem
                        iconSvg='<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>'
                        label="Finding"
                        value={mapData?.name}
                      />
                      <InfoItem
                        iconSvg='<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>'
                        label="Risk"
                        value={
                          <span style={{ color: getRiskColor(mapData?.risk) }}>
                            {mapData?.risk} (CVSS Score: {mapData?.cvssV2?.baseScore})
                          </span>
                        }
                      />
                    </div>

                    <div style={styles?.section}>
                      <h4 style={styles?.sectionTitle}>Short Description</h4>
                      <p style={styles?.sectionContent}>{mapData?.synopsis}</p>
                    </div>

                    <div style={styles?.section}>
                      <h4 style={styles?.sectionTitle}>Recommendation</h4>
                      <p style={styles?.sectionContent}>{mapData?.solution}</p>
                    </div>

                    <div style={styles?.section}>
                      <h4 style={styles?.sectionTitle}>Description</h4>
                      <p style={styles?.sectionContent}>{mapData?.description}</p>
                    </div>

                    <div style={styles?.section}>
                      <h4 style={styles?.sectionTitle}>Reference</h4>
                      <div style={styles?.infoItem}>
                        <span style={styles?.icon} dangerouslySetInnerHTML={{ __html: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>' }} />
                        <a href={mapData?.seeAlso} style={styles.link} target="_blank" rel="noopener noreferrer">
                          {mapData?.seeAlso}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfrastructureVAIP;
